import type { FC } from "react";

import {
  FLEX_ALIGN_CLASS_MAP,
  FLEX_DEFAULTS,
  FLEX_DIRECTION_CLASS_MAP,
  FLEX_JUSTIFY_CLASS_MAP,
  type TFlexProps,
} from "@/ui/components/layout/Flex/Flex.config";
import {
  INLINE_RESPONSIVE_GAP_CLASS_MAP,
} from "@/ui/components/layout/Inline/Inline.config";
import { cn, makeBreakpointClassName } from "@/ui/lib/utils";

export const Flex: FC<TFlexProps> = ({
  direction = FLEX_DEFAULTS.direction,
  align = FLEX_DEFAULTS.align,
  justify = FLEX_DEFAULTS.justify,
  gap = FLEX_DEFAULTS.gap,
  "data-component": component = FLEX_DEFAULTS["data-component"],
  className,
  children,
  ...props
}) => (
  <div
    {...props}
    data-component={component}
    className={cn(
      "flex",
      FLEX_DIRECTION_CLASS_MAP[direction],
      FLEX_ALIGN_CLASS_MAP[align],
      FLEX_JUSTIFY_CLASS_MAP[justify],
      makeBreakpointClassName(
        gap,
        INLINE_RESPONSIVE_GAP_CLASS_MAP,
        FLEX_DEFAULTS.gap,
      ),
      className,
    )}
  >
    { children }
  </div>
);

Flex.displayName = "Flex";
